import React from 'react';
import FlowEditor from './FlowEditor';

export default function AddFlow(props) {
    return <FlowEditor {...props} mode="add"/>;
}
